var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930 -1576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(930 1576)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.793 1606.443l8.817 8.817 18.511-18.51",
    fill: "none",
    stroke: "var(--tickColour, #fff)",
    strokeWidth: 3
  }))));
}
export default SvgTick;